import classNames from 'classnames';
import { Template } from 'devextreme-react';
import { dxElement } from 'devextreme/core/element';
import DataSource, { DataSourceOptions } from 'devextreme/data/data_source';
import dxForm from 'devextreme/ui/form';
import { keysJoin } from 'fulogics-ui-core/dist/api/odata/ODataModel';
import { isDate } from 'fulogics-ui-core/dist/devExtremeInterop/type';
import { useFormData } from 'fulogics-ui-core/dist/layout/hooks/useFormData';
import {
    CarrierTypeModelSimpleTextData,
    CarrierTypeModelSimpleTextDataKeys,
} from 'fulogics-ui-web/dist/layout/components/carrier-type-model-simple-text/CarrierTypeModelSimpleText';
import { LogisticUnitSimpleTextDataKeys } from 'fulogics-ui-web/dist/layout/components/logistic-unit-simple-text/LogisticUnitSimpleText';
import Button from 'fulogics-ui-web/dist/layout/dx/Button/Button';
import CheckBox from 'fulogics-ui-web/dist/layout/dx/CheckBox/CheckBox';
import DataGrid from 'fulogics-ui-web/dist/layout/dx/DataGrid/DataGrid';
import CarrierTypeModelEditColumnTemplate from 'fulogics-ui-web/dist/layout/dx/DataGrid/templates/columns/carrier-type-model-edit-column-template/CarrierTypeModelEditColumnTemplate';
import CarrierTypeModelSimpleTextColumnTemplate from 'fulogics-ui-web/dist/layout/dx/DataGrid/templates/columns/carrier-type-model-simple-text-column-template/CarrierTypeModelSimpleTextColumnTemplate';
import Form from 'fulogics-ui-web/dist/layout/dx/Form/Form';
import { useMemoDataSource } from 'fulogics-ui-web/dist/layout/hooks/useMemoDataSource';
import { useVStore } from 'fulogics-ui-web/dist/layout/hooks/useVStore';
import InspectorVariablesContext from 'fulogics-ui-web/dist/layout/inspector/context/InspectorVariablesContext';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { nameof } from 'ts-simple-nameof';
import { CarrierTypesStore } from '../../../../store/models/CarrierTypesModel';
import {
    COSOrderReturnStepStore,
    setLocationPayload,
    setPlannedStartDatePayload,
} from '../../../../store/models/COSOrderReturnStepModel';
import { insertItemPayload } from '../../../../store/models/COSOrderReturnStepPayloadCollection';
import {
    COSOrderReturnStepPayloadStore,
    deleteItemPayload,
    insertPayloadItemPayload,
} from '../../../../store/models/COSOrderReturnStepPayloadModel';
import { ProductInfoStore } from '../../../../store/models/ProductInfoModel';
import { ReturnStepOriginLocationsStore } from '../../../../store/models/ReturnStepOriginLocationsModel';
import { iRootDispatch, iRootState } from '../../../../store/store';
import ProductInfoColumnTemplate from '../../../templates/dataGrid/column/product-info-column-template/ProductInfoColumnTemplate';
import ProductInfoEditColumnTemplate from '../../../templates/dataGrid/column/product-info-edit-column-template/ProductInfoEditColumnTemplate';
import AllowedStacksHeaderTemplate from '../../../templates/dataGrid/header/allowed-stacks-header-template/AllowedStacksHeaderTemplate';
import { ProductInfoModelSimpleTextDataKeys } from '../../product-info-model-simple-text/ProductInfoModelSimpleText';
import { OrderReturnStepData, OrderReturnStepDataKeys } from '../OrderReturnStepData';
import {
    OrderReturnStepFormFormId,
    orderStepsReturnAddCarrierButtonId,
    orderStepsReturnPayloadGridId,
    orderStepsReturnRemoveStepButtonId,
    orderStepsReturnShowExternalLocationsCheckBoxId,
} from './inspectorOptions';
import styles from './OrderReturnStepForm.module.scss';

// TODO NOW Dodanie przycisku usun nosnik, czy w formie simpleItem - itemType='button'

// TODO
// Koszty dodatkowe w zwiazku z oczekiwaniem kierowcy na dalszy plan (ustalenie z DekaTrans)
// Obliczanie zapełneinia auta
// Kasowanie danego elementu

const mapStateToProps = (state: iRootState) =>
    ({
        createPayloadDataSource: (payloadCollectionId?: string) => {
            let opts = COSOrderReturnStepPayloadStore.createByCollectionId(payloadCollectionId);
            //
            if (!!opts) opts.select = OrderReturnStepPayloadItemDataKeys;
            //
            return opts;
        },
        createOriginLocationsDataSource: (isInternal?: boolean) => {
            let opts = {
                store: ReturnStepOriginLocationsStore,
                filter: ['isInternal', '=', isInternal],
            } as DataSourceOptions;
            //
            opts.select = LogisticUnitSimpleTextDataKeys;
            //
            return opts;
        },
        createCarrierTypesDataSource: () => {
            let opts = {
                store: CarrierTypesStore,
            } as DataSourceOptions;
            //
            opts.select = CarrierTypeModelSimpleTextDataKeys;
            //
            return opts;
        },
    } as OrderReturnStepFormDisplayOptions);

const mapDispatch = (_dispatch: iRootDispatch, _ownDispatch: OrderReturnStepFormDisplayOptions) =>
    ({
        setPlannedStartDate: _dispatch?.COSOrderReturnStep?.setPlannedStartDate,
        setLocation: _dispatch?.COSOrderReturnStep?.setLocation,
        //
        insertPayloadItem: (payload?: insertPayloadItemPayload) =>
            // @ts-ignore
            _dispatch.COSOrderReturnStepPayload.insertPayloadItemToCollection<OrderReturnStepPayloadItemData>(
                {
                    responseDataKeys: OrderReturnStepPayloadItemDataKeys,
                    //
                    ...payload,
                }
            ),
        removeStep: _dispatch?.COSOrderReturnStep?.deleteItem,
        //
        ..._ownDispatch,
    } as OrderReturnStepFormDisplayOptions);

const OrderReturnStepForm = connect(
    mapStateToProps,
    mapDispatch as any
)((props: OrderReturnStepFormProps) => {
    const { t } = useTranslation('OrderReturnStepForm');
    const [showExternalLocations, setShowExternalLocations] = useState<boolean>(false);

    const returnStepMinPlannedStartDate = props.lastForwardStepStartDate
        ? moment(props.lastForwardStepStartDate).add(30, 'minutes').toDate()
        : moment().add(3, 'hours').toDate();

    const data = useMemo(
        () =>
            ({
                ...props.data,
                plannedStartDate: props.data?.plannedStartDate,
            } as OrderReturnStepData),
        [props.data]
    );

    const { formData, updateFieldFormData, updateFieldFormStoreData } = useFormData(data);
    const payloadDataSource = useMemoDataSource(
        () => props.createPayloadDataSource?.(props.data?.payload?.id),
        [props.data?.payload?.id]
    );
    const originLocationsDataSource = useMemoDataSource(
        () => props.createOriginLocationsDataSource?.(!showExternalLocations),
        [showExternalLocations]
    );
    const carrierTypesDataSource = useMemoDataSource(
        () => props.createCarrierTypesDataSource?.(),
        []
    );
    const productInfosDataSource = useMemoDataSource(
        () => ({
            store: ProductInfoStore,
            select: ProductInfoModelSimpleTextDataKeys,
        }),
        []
    );
    const removeStep = useCallback(
        async () => await props.removeStep?.({ itemId: props.data?.id ?? '-1' }),
        [props.removeStep, props.data?.id]
    );
    const vStore = useVStore(
        () => ({
            dataSources: {
                originLocationsDataSource,
                carrierTypesDataSource,
                productInfosDataSource,
            },
            variables: {
                returnStepMinPlannedStartDate,
            },
        }),
        [
            originLocationsDataSource,
            carrierTypesDataSource,
            productInfosDataSource,
            props.isReadOnly,
            props.lastForwardStepStartDate,
        ]
    );

    useEffect(() => {
        originLocationsDataSource?.load();
    }, [originLocationsDataSource]);

    const onFieldDataChanged = async (e: {
        component?: dxForm;
        element?: dxElement;
        model?: any;
        dataField?: string;
        value?: any;
    }) => {
        // @ts-ignore
        if (e.component?._requireRefresh) return;
        //
        props.onFieldDataChanged?.(e.dataField, e.value);
        //
        if (e.dataField === nameof<OrderReturnStepData>((c) => c.plannedStartDate)) {
            const value = isDate(e.value) ? e.value?.toISOString() : e.value;

            await updateFieldFormData(
                e.dataField,
                e.value,
                (value) => {
                    return {
                        plannedStartDate: value,
                    };
                },
                async (id, _) => {
                    await COSOrderReturnStepStore.update(id, {
                        plannedStartDate: value,
                    });
                }
            );
        } else if (e.dataField === nameof<OrderReturnStepData>((c) => c.location!.logisticUnit)) {
            await updateFieldFormData(
                e.dataField,
                e.value,
                (value) => {
                    return {
                        location: {
                            logisticUnitId: value?.id ?? '-1',
                            logisticUnit: value,
                        },
                    };
                },
                async (id, value) => {
                    await props.setLocation?.({
                        id: props.data?.id ?? '-1',
                        //
                        location: {
                            logisticUnitId: value?.id ?? '-1',
                            logisticUnit: value,
                        },
                    });
                },
                (fd) => {
                    return fd?.location;
                }
            );
        }
    };

    const onPayloadAddClick = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        props
            .insertPayloadItem?.({
                collectionId: props.data?.payload?.id ?? '-1',
            })
            .then(() => {});
        payloadDataSource?.reload();
    };

    const onPayloadRowChanged = useCallback(() => {
        props.onFieldDataChanged?.(
            nameof<OrderReturnStepFormData>((q) => q.payload),
            formData.payload
        );
    }, [props.onFieldDataChanged, formData.payload]);

    useEffect(() => {
        const handlePayloadChanged = () => {
            const items = payloadDataSource?.items();
            props.onPayloadChanged?.(items);
        };

        payloadDataSource?.on('changed', handlePayloadChanged);

        return () => {
            payloadDataSource?.off('changed', handlePayloadChanged);
        };
    }, [payloadDataSource, props.onPayloadChanged]);

    useEffect(() => {
        if (props?.data?.id && !props?.data?.plannedStartDate) {
            const fieldName = nameof<OrderReturnStepData>((c) => c.plannedStartDate);

            updateFieldFormData(
                fieldName,
                returnStepMinPlannedStartDate,
                (value) => {
                    return {
                        plannedStartDate: value,
                    };
                },
                async (id, _) => {
                    await COSOrderReturnStepStore.update(id, {
                        plannedStartDate: returnStepMinPlannedStartDate?.toISOString(),
                    });
                }
            );

            props.onFieldDataChanged?.(fieldName, returnStepMinPlannedStartDate);
        }
    }, [props?.data?.id]);

    return (
        <div className={classNames(styles.container, props.className)}>
            <InspectorVariablesContext store={vStore}>
                <form id="orderReturnStepForm" onSubmit={onPayloadAddClick}>
                    <div className={classNames(styles.top)}>
                        <div className={classNames(styles.topLeft)}>{t('loadPlace')}</div>
                        <div>
                            {!props.isReadOnly && (
                                <Button
                                    inspectorId={orderStepsReturnRemoveStepButtonId}
                                    //
                                    onClick={removeStep}
                                />
                            )}
                        </div>
                    </div>
                    <div className={classNames(styles.returnStepDetailsForm)}>
                        <Form
                            inspectorId={OrderReturnStepFormFormId}
                            formData={formData}
                            readOnly={props.isReadOnly}
                            onFieldDataChanged={onFieldDataChanged}
                            className={classNames(styles.orderReturnForm)}
                        />
                        {!props.isReadOnly && (
                            <CheckBox
                                className={classNames(styles.showExternalLocationsCheckBox)}
                                inspectorId={orderStepsReturnShowExternalLocationsCheckBoxId}
                                value={showExternalLocations}
                                onValueChange={setShowExternalLocations}
                            />
                        )}
                    </div>
                    <div className={classNames(styles.gridHeader)}>
                        <div>
                            <div className={classNames(styles.form)}>{t('loadHeader')}</div>
                            <div className={classNames(styles.info)}>{t('loadDescription')}</div>
                        </div>
                        {!props.isReadOnly && (
                            <Button inspectorId={orderStepsReturnAddCarrierButtonId} />
                        )}
                    </div>
                    <div>
                        <DataGrid
                            inspectorId={orderStepsReturnPayloadGridId}
                            repaintChangesOnly
                            twoWayBindingEnabled
                            dataSource={payloadDataSource}
                            onRowUpdated={onPayloadRowChanged}
                            onRowRemoved={onPayloadRowChanged}
                            editing={{
                                allowDeleting: !props.isReadOnly,
                                allowUpdating: !props.isReadOnly,
                                mode: 'cell',
                                useIcons: false,
                            }}
                        >
                            <Template
                                name="AllowedStacksHeader"
                                render={AllowedStacksHeaderTemplate}
                            />
                            <Template
                                name="ProductInfoEditColumn"
                                render={ProductInfoEditColumnTemplate}
                            />
                            <Template name="ProductInfoColumn" render={ProductInfoColumnTemplate} />
                            <Template
                                name="CarrierTypeModelSimpleTextColumn"
                                render={CarrierTypeModelSimpleTextColumnTemplate}
                            />
                            <Template
                                name="CarrierTypeModelEditColumn"
                                render={CarrierTypeModelEditColumnTemplate}
                            />
                        </DataGrid>
                    </div>
                </form>
            </InspectorVariablesContext>
        </div>
    );
});
export default OrderReturnStepForm;

export type OrderReturnStepFormProps = {
    data?: OrderReturnStepFormData;
} & OrderReturnStepFormDisplayOptions;

export class OrderReturnStepFormDisplayOptions {
    className?: string;
    //
    createPayloadDataSource?: (
        payloadCollectionId?: string
    ) => DataSource | DataSourceOptions | undefined;
    createOriginLocationsDataSource?: (
        isInternal?: boolean
    ) => DataSource | DataSourceOptions | undefined;
    createCarrierTypesDataSource?: () => DataSource | DataSourceOptions | undefined;
    //
    onFieldDataChanged?: (dataField?: string, value?: any) => void;
    onPayloadChanged?: (items?: OrderReturnStepPayloadItemData[]) => void;
    //
    setPlannedStartDate?: (payload: setPlannedStartDatePayload) => void;
    setLocation?: (payload: setLocationPayload) => void;
    insertPayloadItem?: (payload: insertItemPayload) => Promise<void>;
    //
    removeStep?: (payload: deleteItemPayload) => Promise<void>;
    //
    isReadOnly?: boolean;
    lastForwardStepStartDate?: Date;
}

export type OrderReturnStepFormData = OrderReturnStepData;
export const OrderReturnStepFormDataKeys = OrderReturnStepDataKeys;

export type OrderReturnStepPayloadProductItemData = {
    id?: string;
    sku?: string;
    name?: string;
};
export const OrderReturnStepPayloadProductItemDataKeys = ['id', 'sku', 'name'];

export type OrderReturnStepPayloadItemData = {
    id?: string;
    carrierType?: CarrierTypeModelSimpleTextData;
    count?: number;
    product?: OrderReturnStepPayloadProductItemData;
    maximumAllowedStacks?: number;
};

export const OrderReturnStepPayloadItemDataKeys = [
    'id',
    'count',
    'maximumAllowedStacks',
    ...keysJoin(CarrierTypeModelSimpleTextDataKeys, 'carrierType.'),
    ...keysJoin(OrderReturnStepPayloadProductItemDataKeys, 'product.'),
];
